import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
    DEFAULT_SITE_SETTINGS,
    fetchPublicSiteSettings,
    normalizeSiteSettings,
    readCachedSiteSettings,
    resolveSettingAssetUrl,
    writeCachedSiteSettings,
} from '../utils/siteSettingsApi';

const SiteSettingsContext = createContext(null);

function buildContextValue(settings, ready) {
    return {
        ...settings,
        ready,
        headerLogoUrl: resolveSettingAssetUrl(settings.header_logo),
        headerLogoLightUrl: resolveSettingAssetUrl(settings.header_logo_light),
        faviconUrl: resolveSettingAssetUrl(settings.favicon),
        loaderIconUrl: resolveSettingAssetUrl(settings.loader_icon),
    };
}

export function SiteSettingsProvider({ children }) {
    const cached = typeof window !== 'undefined' ? readCachedSiteSettings() : null;
    const [settings, setSettings] = useState(cached || normalizeSiteSettings(null));
    const [ready, setReady] = useState(Boolean(cached));

    useEffect(() => {
        let cancelled = false;
        fetchPublicSiteSettings().then((next) => {
            if (cancelled) return;
            writeCachedSiteSettings(next);
            setSettings(next);
            setReady(true);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    const value = useMemo(() => buildContextValue(settings, ready), [settings, ready]);

    return (
        <SiteSettingsContext.Provider value={value}>
            {children}
        </SiteSettingsContext.Provider>
    );
}

export function useSiteSettings() {
    const ctx = useContext(SiteSettingsContext);
    if (!ctx) {
        return buildContextValue(normalizeSiteSettings(DEFAULT_SITE_SETTINGS), true);
    }
    return ctx;
}
